var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCashAcceptor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Cash_Acceptor"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cash_Acceptor",
    "data-name": "Cash Acceptor",
    clipPath: "url(#clip-Cash_Acceptor)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "payout",
    transform: "translate(-4 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M56.889,28.576V43.39a1.852,1.852,0,0,1-1.852,1.852A16.667,16.667,0,0,0,38.37,61.909a1.852,1.852,0,0,1-3.7,0,20.37,20.37,0,0,1,8.648-16.667H18V61.909A11.111,11.111,0,0,0,29.111,73.02H56.889A11.111,11.111,0,0,0,68,61.909c0-36.056.667-34.907-1.852-37.37a5.444,5.444,0,0,0-9.259,4.037Z",
    transform: "translate(10.222 14.461)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 43,
    height: 15,
    rx: 2,
    transform: "translate(32 91)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M59.148,45.492H23.963a1.852,1.852,0,0,1-1.852-1.852,5.556,5.556,0,0,0-5.556-5.556A1.852,1.852,0,0,1,14.7,36.232V17.714a1.852,1.852,0,0,1,1.852-1.852,5.556,5.556,0,0,0,3.907-1.611c.37-.37,1.519-.241-9.463-.241V43.64A5.556,5.556,0,0,0,16.556,49.2H59.148Z",
    transform: "translate(4.259 6.805)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M76.111,35.2a9.259,9.259,0,0,1,1.852-.611V19.4A9.111,9.111,0,0,1,73.407,17a9.741,9.741,0,0,1-2.074-2.963H54.019c7.407,8.463,2.611,24.074-7.537,24.074s-14.815-15.63-7.519-24.074c-17.556,0-17.333-.167-17.333,0A9.259,9.259,0,0,1,15,19.4V34.59a9.259,9.259,0,0,1,7.222,7.222H55.741c0-5.185-.593-8.759,2.7-12.093a9.259,9.259,0,0,1,15.815,6.537A8.945,8.945,0,0,1,76.111,35.2Z",
    transform: "translate(7.667 6.781)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M48.665,14.248a5.556,5.556,0,0,0,3.907,1.611,1.852,1.852,0,0,1,1.852,1.852V36.23a1.852,1.852,0,0,1-1.852,1.852,5.556,5.556,0,0,0-3.944,1.63c-2.037,2.074-1.611,3.926-1.611,9.481,6.037,0,6.037,0,7-.2a5.556,5.556,0,0,0,4.111-5.352V14.008C47.443,14.008,48.239,13.9,48.665,14.248Z",
    transform: "translate(34.909 6.807)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M96.741,6H11.556A5.556,5.556,0,0,0,6,11.556V26.37a5.556,5.556,0,0,0,5.556,5.556V20.815a1.852,1.852,0,0,1,0-3.7H96.741a1.852,1.852,0,1,1,0,3.7V31.926A5.556,5.556,0,0,0,102.3,26.37V11.556A5.556,5.556,0,0,0,96.741,6Z",
    transform: "translate(0 0)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 7.5,
    cy: 10,
    rx: 7.5,
    ry: 10,
    transform: "translate(47 21)",
    fill: "#e8eaf0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashAcceptor);
export default __webpack_public_path__ + "static/media/cash-acceptor.1857f4d24b86d79c1c3546aa7030b8da.svg";
export { ForwardRef as ReactComponent };